import { render } from "./SelectDropdown.vue?vue&type=template&id=122bc053"
import script from "./SelectDropdown.vue?vue&type=script&lang=js"
export * from "./SelectDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script